/**
 * PublicNav.tsx
 * Sticky navigation bar shared across all public-facing pages (About, Terms, Privacy).
 * Uses ab- CSS classes defined in AboutPage.css.
 */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkAuthStatus } from '../../api/user';
import { AppLink } from './AppLink';
import { isMarketingHost } from '../../config/site';

export function PublicNav() {
  // On the marketing host there is no session (cookies live on the app host), so
  // skip the auth probe and always offer "Sign in" into the app.
  const [isAuthed, setIsAuthed] = useState<boolean | null>(isMarketingHost() ? false : null);

  useEffect(() => {
    if (isMarketingHost()) return;
    checkAuthStatus().then(setIsAuthed).catch(() => setIsAuthed(false));
  }, []);

  return (
    <nav className="ab-nav" aria-label="Site navigation">
      <div className="ab-nav-inner">
        <Link to={isMarketingHost() ? '/' : '/about'} className="ab-nav-brand">
          <img className="ab-nav-logo" src="/logo_sq.png" alt="Catty logo" />
          <span className="ab-nav-brand-name">Catty <span>by Joined-Up Data</span></span>
        </Link>
        <AppLink
          to={isAuthed ? '/' : '/login'}
          className="ab-btn ab-btn-primary"
          style={{ opacity: isAuthed === null ? 0 : 1, transition: 'opacity 0.3s ease', pointerEvents: isAuthed === null ? 'none' : undefined }}
        >
          {isAuthed ? 'Dashboard' : 'Sign in'}
        </AppLink>
      </div>
    </nav>
  );
}
